import { type BlaBlaDailyProviderOffer, type ProviderOffer } from "../../../../../types/dtos/api/sales/provider-offer.dto";
import { isFiniteNonNegativeNumber } from "../helpers/OfferPricingNumber.helper";
import { resolveBookingUrlFromBookingUrls } from "../helpers/OfferPricingUrl.helper";
import { type OfferPricingEvaluationContext, type ProviderPricingEvaluation } from "../OfferPricing.types";
import { BaseOfferPricingProvider } from "../OfferPricingProvider.contract";

export class BlabladailyOfferPricingProvider extends BaseOfferPricingProvider {

    /**
     * Creates the BlaBlaDaily pricing provider plugin.
     */
    public constructor() {
        super( "blabladaily" );
    }

    /**
     * Normalizes BlaBlaDaily price and booking URL values.
     *
     * @param _ Segment context (unused for this provider).
     * @param providerOffer Raw provider payload.
     * @returns Normalized provider evaluation.
     */
    public evaluate( _: OfferPricingEvaluationContext, providerOffer: ProviderOffer ): ProviderPricingEvaluation {
        const typedOffer = providerOffer as BlaBlaDailyProviderOffer;
        const price = isFiniteNonNegativeNumber( typedOffer.price ) ? typedOffer.price : null;
        const bookingUrl = resolveBookingUrlFromBookingUrls( typedOffer.bookingUrls );

        return {
            "providerKey":  typedOffer.provider,
            "providerName": this.getProviderLabel(),
            price,
            bookingUrl,
        };
    }

}

export const blabladailyOfferPricingProviderPlugin = new BlabladailyOfferPricingProvider();
